<template>
    <div>
        <div class="form-group">
            <label for="contract_type">Soort contract <small class="text-danger">*</small></label>
            <select v-model="contract_type" class="form-control custom-select" id="contract_type" name="contract_type">
                <option v-for="(value, key) in contract_types" :value="key">{{ value }}</option>
            </select>
        </div>

        <template v-if="contract_type == 1">
            <div class="d-flex">
                <div class="form-group w-50 mr-2">
                    <label for="min_hours">Min uren per week <small class="text-danger">*</small></label>
                    <input v-model="min_hours" class="form-control" v-bind:class="{'is-invalid' : this.errors && this.errors.min_hours}" type="text" id="min_hours" name="min_hours" placeholder="Min">
                    <small v-if="this.errors && this.errors.min_hours" class="text-danger">{{this.errors.min_hours[0]}}</small>
                </div>

                <div class="form-group w-50">
                    <label for="max_hours">Max uren per week <small class="text-danger">*</small></label>
                    <input v-model="max_hours" class="form-control" v-bind:class="{'is-invalid' : this.errors && this.errors.max_hours}" type="text" id="max_hours" name="max_hours" placeholder="Max">
                    <small v-if="this.errors && this.errors.max_hours" class="text-danger">{{this.errors.max_hours[0]}}</small>
                </div>
            </div>
        </template>


        <div v-if="contract_type == 2" class="form-group">
            <label for="hours">Uren per week <small class="text-danger">*</small></label>
            <input v-model="hours" class="form-control" v-bind:class="{'is-invalid' : this.errors && this.errors.hours}" type="text" id="hours" name="hours" placeholder="Uren">
            <small v-if="this.errors && this.errors.hours" class="text-danger">{{this.errors.hours[0]}}</small>
        </div>

        <div class="form-group">
            <div class="position-relative flex align-items-center mb-0">
                <label for="extra_statutory">Heb je recht op bovenwettelijke verlof?</label>
                <div>
                    <div class="info-circle-wrap">
                        <div class="info-circle">
                            <span class="info-text">?</span>
                        </div>
                    </div>
                    <div class="info-pop-up-wrap info-pop-up-wrap--hide">
                        <div class="info-pop-up">
                            <p class="mb-0">
                                Extra verlofdagen bovenop het wettelijke aantal verlofdagen worden bovenwettelijke verlofdagen genoemd.
                                <br>
                                Heb jij recht op bovenwettelijke verlofdagen? Geef aan om hoeveel <b>uur</b> dit gaat.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <select v-model="extra_statutory" class="form-control custom-select" id="extra_statutory" name="extra_statutory">
                <option :value="true">Ja</option>
                <option :value="false">Nee</option>
            </select>
        </div>

        <div v-if="extra_statutory" class="form-group">
            <input v-model="extra_statutory_time" type="number" step="0.01" class="form-control" min="0" v-bind:class="{'is-invalid' : this.errors && this.errors.extra_statutory_hours}" id="extra_statutory_hours" name="extra_statutory_hours" placeholder="Op hoeveel bovenwettelijke verlofuren heb je recht?">
            <small v-if="this.errors && this.errors.extra_statutory_hours" class="text-danger">{{this.errors.extra_statutory_hours[0]}}</small>
        </div>

    </div>
</template>


<script>
    export default {
        data() {
            return {
                contract_type: 0,
                hours: 0,
                min_hours: 0,
                max_hours: 0,
                extra_statutory: false,
                extra_statutory_time: 0
            }
        },
        props: {
            errors: {},
            old: {},
            contract_types: {},
            old_contract: {},
            old_extra_statutory_time: 0,
        },
        mounted() {
            if (this.old_extra_statutory_time > 0){
                this.extra_statutory = true;
                this.extra_statutory_time = this.old_extra_statutory_time;
            }
            if(Object.keys(this.old).length > 0)
            {
                this.contract_type = this.old.contract_type;

                if(this.contract_type == 1)
                {
                    this.min_hours = this.old.min_hours;
                    this.max_hours = this.old.max_hours;
                }
                else if(this.contract_type == 2)
                {
                    this.hours = this.old.hours;
                }
            }
            else if(this.old_contract)
            {
                this.contract_type = this.old_contract.type;

                if(this.old_contract.type == 1)
                {
                    this.min_hours = this.old_contract.min_hours;
                    this.max_hours = this.old_contract.max_hours;
                }
                else if(this.old_contract.type == 2)
                {
                    this.hours = this.old_contract.min_hours;
                }
            }
        },
    }
</script>
